import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { getBucketDownloadUrl } from "./apis/firebase";

import resourcesToBackend from "i18next-resources-to-backend";

import axios from "axios";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function initializeTranslation(storage: any, storageBucket: string): void {
  const enBucketURl = `gs://${storageBucket}/public/en.json`;
  const frBucketURL = `gs://${storageBucket}/public/fr.json`;

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(
      resourcesToBackend(async (ln, namespace, callback) => {
        let jsonUrl;
        if (ln === "en") {
          jsonUrl = await getBucketDownloadUrl(enBucketURl);
        } else if (ln === "fr") {
          jsonUrl = await getBucketDownloadUrl(frBucketURL);
        }
        const _axios = axios.create({});
        _axios
          .get(jsonUrl)
          .then((resources) => {
            // console.log("resources", resources.data);
            callback(null, resources.data);
          })
          .catch((error) => {
            callback(error, null);
          });
      })
    )
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      lng: window.localStorage.getItem("default_lang") || "en",
      fallbackLng: "en",
      debug: false,
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ",",
      },
      react: {
        useSuspense: true,
        wait: true,
      },
    });

  return i18n;
}
export default initializeTranslation;
export { i18n };
